import BaseApiRequest from "./BaseApiRequest";
import { URL_VERIFICATION_GET } from "../ApiUrls";
import { METHOD } from "../Constants";

export default class PlaidVerificationGetRequest extends BaseApiRequest {
  method = METHOD.HTTP.GET;

  constructor(linkSessionId) {
    super();
    this.linkSessionId = linkSessionId;
  }

  getMethod = () => this.method;

  getUrl = () => `${URL_VERIFICATION_GET}?linkSessionId=${this.linkSessionId}`;

  getBody = () => ({});
}
